import styled from 'styled-components';

import { spaceL } from '@xing-com/tokens';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${spaceL};
`;

export { Container };
